import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import cammeraBtn from "../assets/click.png";
import logo from "../assets/logo.png";
import retake from "../assets/re.png";
import submit from "../assets/ok.png";
import loader from "../assets/loading.gif";
import {
  registerUserService,
  deepfakeService,
} from "../Service/RegisterService";
import { toast } from "react-toastify";

// import { registerUserService } from "../Service/RegisterService";

function Camera() {
  const cameraRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { name, gender } = location.state || {};
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    if (cameraRef.current) {
      const screenshot = cameraRef.current.getScreenshot();
      setImage(screenshot);
    }
  };

  const handleApi = async (image) => {
    try {
      // First register the user to get user_id
      const registerData = await registerUserService({
        name,
        gender,
        file: image,
      });

      // Then use the user_id for deepfake
      const deepfakeData = await deepfakeService({
        image,
        gender,
        user_id: registerData.user_id,
      });

      navigate("/thankyou", {
        state: {
          registerData,
          deepfakeData,
          image,
          gender,
        },
      });
    } catch (error) {
      console.log(error);
      toast("Server is down, please try again later");
    }
  };

  const handleProceed = async () => {
    setLoading(true);
    await handleApi(image);
    setLoading(false);
  };

  const handleReset = () => {
    setImage(null);
  };

  const videoConstraints = {
    width: 720,
    height: 720,
    facingMode: "user",
  };

  if (loading) {
    return (
      <div className="flex flex-col backdrop-blur-sm h-full">
        <div className="flex justify-center font-bold text-white py-14 text-center">
          <img
            src={logo}
            alt=""
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="flex items-center justify-center flex-col h-[40%] gap-8">
          <img src={loader} alt="loading" className="w-60" />
          <div className="text-[#002248] text-[40px] font-semibold">
            Please Wait
          </div>
        </div>
      </div>
    );
  }

  if (image) {
    return (
      <div className="flex justify-center flex-col backdrop-blur-sm">
        <div className="flex justify-center font-bold text-white py-14 backdrop-blur-sm text-center">
          <img
            src={logo}
            alt=""
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="flex flex-col items-center mb-16">
          <div
            className="p-3 rounded-full shadow-lg"
            style={{
              background:
                "linear-gradient(115deg, #66ccff, #ffcc66, #ff9933, #33cc33)",
            }}
          >
            <img
              src={image}
              alt="loading"
              className="transform scale-x-[-1] rounded-full object-cover"
            />
          </div>
        </div>

        <div className="box-border flex justify-center items-center gap-[10em] w-full ">
          <img src={retake} alt="" onClick={handleReset} />
          <img src={submit} alt="" onClick={handleProceed} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center flex-col backdrop-blur-sm">
      <div className="flex justify-center font-bold text-white py-14 text-center">
        <img
          src={logo}
          alt=""
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="flex flex-col items-center px-12 mb-10">
        <div
          className="p-3 rounded-full shadow-lg"
          style={{
            background:
              "linear-gradient(115deg, #66ccff, #ffcc66, #ff9933, #33cc33)",
          }}
        >
          <div className="relative w-full aspect-square bg-gray-500 rounded-full overflow-hidden">
            <Webcam
              className="w-full h-full transform scale-x-[-1]"
              audio={false}
              ref={cameraRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
            />
          </div>
        </div>
      </div>

      <div className="z-20  bottom-[5%] w-full flex justify-center items-center flex-col">
        <div className="flex justify-center items-center w-[70%]">
          <img
            src={cammeraBtn}
            onClick={handleClick}
            className="w-[20vw]"
            alt="Capture"
          />
        </div>
        <p className="text-center text-[#002248] text-2xl pt-4">
          CLICK YOUR SELFIE
        </p>
      </div>
    </div>
  );
}

export default Camera;
